export class QuestionBankViewReq {
    classId: number;
    subject: number;
    chapter: number;
    marks: number;
    language: number;
    activeOnly?: boolean;
    subjectName?: string;
    ability?: number;
    abilityType?: number;
    complexity?: number;
    questionType?: number;
    approvalStatus?: string;

    constructor(
        classId: number,
        subject: number,
        chapter: number,
        marks: number,
        language: number,
        activeOnly?: boolean,
        subjectName?: string,
        ability?: number,
        abilityType?: number,
        complexity?: number,
        questionType?: number
    ) {
        this.classId = classId;
        this.subject = subject;
        this.chapter = chapter;
        this.language = language;
        this.marks = marks;
        this.activeOnly = activeOnly;
        this.subjectName = subjectName;
        this.ability = ability;
        this.abilityType = abilityType;
        this.complexity = complexity;
        this.questionType = questionType;
    }
}